exports.Collapse = require('./Collapse')
exports.Item = require('./Item')



// WEBPACK FOOTER //
// ./~/vue-bulma-collapse/src/index.js